/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralLvSubjectDto } from './nonCadastralLvSubjectDto.model';
import { NonCadastralSource } from './nonCadastralSource.model';


export interface NonCadastralLvOwnershipDto { 
    delivered?: boolean;
    distinctChar?: string;
    katuzeKod?: number;
    lv?: number;
    opsubId?: number;
    podilCitatel?: number;
    podilJmenovatel?: number;
    source?: NonCadastralSource;
    subject?: NonCadastralLvSubjectDto;
}
export namespace NonCadastralLvOwnershipDto {
}


